import { setRequest } from '@sancare/typescript-commons/src/misc/api'

export const mutations = {
  setRequest,
}
